import { DOCUMENT_PATH } from 'config/api.routes';
import services from 'service/axios';
import { handleResponse } from 'utils/responseTransformer';

import type { GenericResponse } from 'commons/modules/generic-response';
import {
  DeleteUploadedFileResponse,
  UpdateExpirationDateResponse,
} from 'commons/modules/service/download-uploaded-files';

const downloadUploadedFilesService = async (
  id: number,
  filename: string,
): Promise<GenericResponse<any>> => {
  try {
    const res = await services.wt_api(
      `${DOCUMENT_PATH}/documents/download?clientId=${id}&filename=${filename}`,
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
        },
      },
    );

    const { data, status, headers } = res;
    return handleResponse(data, status, true, null, null, undefined, headers);
  } catch (error: any) {
    return handleResponse(null, error.status, false, error);
  }
};

export const deleteUploadedFilesService = async (
  documentId: number,
): Promise<GenericResponse<DeleteUploadedFileResponse>> => {
  const res = await services.wt_api(
    `${DOCUMENT_PATH}/documents/remove?documentId=${documentId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    },
  );

  const { data, status, headers } = res;
  return handleResponse(data, status, true, null, null, undefined, headers);
};

export const updateExpirationDateService = async (
  documentId: number,
  expirationDate: string | null,
): Promise<GenericResponse<UpdateExpirationDateResponse>> => {
  const res = await services.wt_api(
    `${DOCUMENT_PATH}/documents/expirationDate`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      data: JSON.stringify({ documentId, expirationDate }),
    },
  );

  const { data, status, headers } = res;
  return handleResponse(data, status, true, null, null, undefined, headers);
};

export default downloadUploadedFilesService;
